import React from "react";
import { useLanguage } from "../../../../context/LanguageContext";
import { useAdminSettingsTranslation } from "../translations";

const SocialMediaSettings = ({ storeData, handleChange }) => {
    const { language } = useLanguage();
    const { t } = useAdminSettingsTranslation(language);

    return (
        <div className="social-media-settings-section">
            <h2>{t('socialMediaSettings')}</h2>

            <div className="form-group">
                <label htmlFor="facebook">{t('facebookUrl')}</label>
                <input
                    type="url"
                    id="facebook"
                    name="socialMedia.facebook"
                    value={storeData.socialMedia.facebook}
                    onChange={handleChange}
                    placeholder="https://facebook.com/yourstore"
                />
            </div>

            <div className="form-group">
                <label htmlFor="instagram">{t('instagramUrl')}</label>
                <input
                    type="url"
                    id="instagram"
                    name="socialMedia.instagram"
                    value={storeData.socialMedia.instagram}
                    onChange={handleChange}
                    placeholder="https://instagram.com/yourstore"
                />
            </div>

            <div className="form-group">
                <label htmlFor="twitter">{t('twitterUrl')}</label>
                <input
                    type="url"
                    id="twitter"
                    name="socialMedia.twitter"
                    value={storeData.socialMedia.twitter}
                    onChange={handleChange}
                    placeholder="https://twitter.com/yourstore"
                />
            </div>

            <div className="form-group">
                <label htmlFor="tiktok">{t('tiktokUrl') || 'TikTok URL'}</label>
                <input
                    type="url"
                    id="tiktok"
                    name="socialMedia.tiktok"
                    value={storeData.socialMedia.tiktok || ''}
                    onChange={handleChange}
                    placeholder="https://tiktok.com/@yourstore"
                />
            </div>
        </div>
    );
};

export default SocialMediaSettings;